__turbopack_context__.v({
  "companyName": "EnqueuedQuestionnaireItem-module__TxETJq__companyName",
  "entityId": "EnqueuedQuestionnaireItem-module__TxETJq__entityId",
  "item": "EnqueuedQuestionnaireItem-module__TxETJq__item",
  "templateName": "EnqueuedQuestionnaireItem-module__TxETJq__templateName",
});
